import { render, staticRenderFns } from "./PropertyPanel.vue?vue&type=template&id=5ca8a73f&scoped=true"
import script from "./PropertyPanel.vue?vue&type=script&lang=js"
export * from "./PropertyPanel.vue?vue&type=script&lang=js"
import style0 from "./PropertyPanel.vue?vue&type=style&index=0&id=5ca8a73f&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ca8a73f",
  null
  
)

export default component.exports